import { Schema as S } from "effect";
import { StatutoryInsurerSchema } from "./insurance-search.response";

/**
 * Get Insurer By IK Response Schema
 *
 * Returns a single insurer or null if not found.
 *
 * @since 1.0.0
 */
export const GetInsurerByIkResponseSchema = S.NullOr(StatutoryInsurerSchema);

export type GetInsurerByIkResponse = S.Schema.Type<
  typeof GetInsurerByIkResponseSchema
>;
